<template>
  <van-popup :value="value" @input="input" position="bottom" round>
    <div style="width:100vw;height:352px" class="flex flex-col items-center p-4 relative">
      <div class="text-center main-color">Flavor</div>
      <div class="flex flex-row items-center justify-between" style="margin-top:67px">
        <van-image :src="productInfo.deviceImage" width="100" fit="contain"/>
        <div class="ml-9">
          <div>{{ productInfo.deviceName }}</div>
          <div class="flavor-name-tags">
            <div class="flavor-tag-content">
              <span v-for="(tag,index) in tags" :key="index" class="flavor-tag">{{ tag.labelName }}</span>
            </div>
          </div>

        </div>
      </div>

      <div v-if="showButton" class="flex flex-row items-center text-center gap-3 mt-10 absolute bottom-2 left-4 right-4">
        <div @click="onCancelClick" class="flex-1 bg-white write-btn radius-border">{{ cancelText }}</div>
        <div @click="onWriteClick" class="flex-1 text-white write-btn"
            style="background: #121212"> {{ScanOrWriteText}}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "PopupFlavorWrite",
  props: {
    showButton: {
      type:Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true
    },
    productInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tags: {
      type: Array,
      default: () => {
        return [];
      }
    },
    funcType: {
      type:Number,
      default: 1 //1是扫码 2是NFC
    },
    cancelText: {
      type:String,
      default: 'Cancel'
    }
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    onWriteClick() {
      this.$emit("onWrite");
      this.$emit("input", false);
    },
    onCancelClick() {
      this.$emit("onCancel");
    }
  },
  computed:{

    ScanOrWriteText() {
      if (this.funcType === 1) {
        return 'Scan'
      }else if (this.funcType === 2) {
        return 'Write'
      }
      return ``
    }
  }
};
</script>

<style scoped lang="less">

.flavor-name-tags {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: scroll;

  .flavor-name {
    font-size: 15px;
  }

  .flavor-tag-content {
    margin-top: 10px;
    display: flex;
    flex: 1;
    font-size: 10px;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;

    .flavor-tag {
      border-radius: 8px;
      background: var(--modeActiveBackground) !important;
      color: var(--modeActiveTextColor) !important;
      padding: 4px 8px;
      margin-right: 4px;
    }
  }
}

.write-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>